import { WA_NUMBER } from './products'

export interface Offer {
  id: number
  name: string
  includes: string[] // products inside a combo; empty array for a single product
  originalPrice: number
  offerPrice: number
  savings: number
  image: string
  /**
   * Acercamiento extra de la foto cuando el producto queda chico dentro del
   * encuadre original. 1 = sin acercar.
   */
  imageZoom?: number
  pain: string
  description: string
  benefits: string[]
  waMessage: string
}

export const offers: Offer[] = [
  {
    id: 1,
    name: 'Combo Fuerza + Masa',
    includes: [
      'Isolate Protein Mix 900g (Profit)',
      'Creatine POWER 300g (Profit)',
    ],
    originalPrice: 2290,
    offerPrice: 1490,
    savings: 800,
    image:
      'https://cdn.magicpatterns.com/uploads/g2gkabWXWwXzgMAADaGtf5/Isolate_protein_mix_y_creatine_powder.jpg',
    pain: 'El atleta que quiere ganar músculo y fuerza pero gasta de más comprando cada suplemento por separado.',
    description:
      'Proteína de alta calidad + creatina pura en un solo combo económico para crecer más rápido. La combinación perfecta para construir músculo y potenciar tu fuerza desde el primer mes.',
    benefits: [
      'Proteína de alta concentración por porción',
      'Creatina pura para más fuerza y potencia',
      'Ahorrás comprando ambos juntos',
      'Ideal para ganar masa muscular',
      'Recuperación muscular acelerada',
      'El combo más vendido para empezar',
    ],
    waMessage:
      'Hola! Quiero el Combo Fuerza + Masa — Isolate Protein Mix 900g + Creatine POWER 300g por $1.490 UY. ¿Tienen stock disponible?',
  },
  {
    id: 2,
    name: 'Combo Masa + Creatina',
    imageZoom: 1.3,
    includes: [
      'Anabolic MASS 28500 3kg (Profit)',
      'Creatine POWER 300g (Profit)',
    ],
    originalPrice: 2590,
    offerPrice: 1690,
    savings: 900,
    image:
      'https://cdn.magicpatterns.com/uploads/cmh1V2TfazNJ6qCDbNRVdm/Anabolic_Mass_3kg_2B_Creatine_POWER_300g.jpg',
    pain: 'Querés ganar masa muscular y potenciar tu fuerza pero comprar cada suplemento por separado se va de presupuesto.',
    description:
      'Hipercalórico de alta calidad + creatina potente para ganar volumen y fuerza en un solo combo accesible. El stack ideal para hardgainers que quieren resultados de verdad.',
    benefits: [
      'Hipercalórico con 28.500mg de activos',
      'Creatina potente para fuerza explosiva',
      'Superávit calórico controlado',
      'Ideal para ganar peso y volumen',
      '3kg de combustible puro',
      'Resultados visibles en pocas semanas',
    ],
    waMessage:
      'Hola! Quiero el Combo Masa + Creatina — Anabolic MASS 28500 3kg + Creatine POWER 300g por $1.690 UY. ¿Tienen stock disponible?',
  },
  {
    id: 3,
    name: 'Combo Definición Total',
    imageZoom: 1.3,
    includes: [
      'Isolate Protein Mix 900g (Profit)',
      'Creatine POWER 300g (Profit)',
      'Pro Abdomen 60 Caps (Profit)',
    ],
    originalPrice: 2590,
    offerPrice: 1990,
    savings: 600,
    image:
      'https://cdn.magicpatterns.com/uploads/w4t68R7iTURZ63PtmY88qT/Isolate_2B_Creatine_2B_Pro_abdomen.jpg',
    pain: 'Querés definir tu físico, ganar fuerza y quemar grasa abdominal pero armar el stack completo te sale caro.',
    description:
      'Proteína + creatina + termogénico en un solo combo. Todo lo que necesitás para definir y rendir al máximo. El pack completo para los que quieren músculo marcado y bajo porcentaje de grasa.',
    benefits: [
      'Proteína de alta calidad para músculo',
      'Creatina para fuerza y rendimiento',
      'Termogénico para quemar grasa',
      'Favorece la definición abdominal',
      'Stack completo de definición',
      'Máximo aprovechamiento de tu entrenamiento',
    ],
    waMessage:
      'Hola! Quiero el Combo Definición Total — Isolate Protein Mix 900g + Creatine POWER 300g + Pro Abdomen 60 Caps por $1.990 UY. ¿Tienen stock disponible?',
  },
  {
    id: 5,
    name: 'Pro Abdomen 60 Caps — Profit',
    includes: [],
    originalPrice: 990,
    offerPrice: 690,
    savings: 300,
    image:
      'https://cdn.magicpatterns.com/uploads/kAprmK88P6DQyeVRcH72oe/Pro_abdomen.jpg',
    pain: '¿Entrenás abdominales todos los días pero la grasa abdominal no se va? Por más ejercicio que hagas, sin el apoyo metabólico correcto, esa capa de grasa sigue tapando tu progreso.',
    description:
      'Pro Abdomen de Profit es un suplemento termogénico diseñado para potenciar la quema de grasa abdominal. Con ingredientes que aceleran el metabolismo y favorecen la definición, es el complemento perfecto para tu dieta y entrenamiento.',
    benefits: [
      'Potencia la quema de grasa localizada',
      'Acelera el metabolismo naturalmente',
      'Favorece la definición abdominal',
      'Complemento ideal para dieta y cardio',
      '60 cápsulas — fácil de tomar',
      'Resultados visibles con constancia',
    ],
    waMessage:
      'Hola! Quiero el Pro Abdomen 60 Caps en oferta por $690 UY. ¿Tienen stock disponible?',
  },
  {
    id: 6,
    name: 'Whey Protein Cibeles 4 LB',
    includes: [],
    originalPrice: 5480,
    offerPrice: 4190,
    savings: 1290,
    image:
      'https://cdn.magicpatterns.com/uploads/xjQLVWgkkVp9hcLxyfqdVt/Whey_Protein_Cibeles4lb.jpg',
    pain: 'Ya sabés lo que es la whey y la necesitás de forma consistente. Cada vez que se te acaba, perdés días sin suplementarte y eso afecta tu progreso semana a semana.',
    description:
      'Para el atleta que ya sabe que la proteína es no-negociable. 4 libras de whey protein CIBELES para mantener tu suplementación sin interrupciones, con el mejor costo por porción y la calidad que ya conocés y confiás.',
    benefits: [
      '4 LB para suplementación continua',
      'Mejor costo-beneficio por porción',
      'Proteína completa de alta absorción',
      'Para atletas de entrenamiento regular',
      'Sin cortes en tu suplementación',
      'Resultados sostenidos en el tiempo',
    ],
    waMessage:
      'Hola! Quiero el Whey Protein Cibeles 4 LB en oferta por $4.190 UY. ¿Tienen stock disponible?',
  },
  {
    id: 7,
    name: 'Anabolic MASS 28500 3kg — Profit',
    includes: [],
    originalPrice: 1860,
    offerPrice: 1390,
    savings: 470,
    image:
      'https://cdn.magicpatterns.com/uploads/3a2vVnSjXyQF7cG2wEnThv/Anabolic_Mass.jpg',
    pain: '¿Comés de todo y no subís ni un kilo? Tu metabolismo quema calorías más rápido de lo que las consumís. Sin un superávit calórico real, tu cuerpo no tiene material para construir músculo nuevo.',
    description:
      'Anabolic MASS 28500 de Profit es el hipercalórico más completo del mercado. Con 28.500mg de activos por porción, combina proteínas, carbohidratos complejos, creatina y glutamina en 3kg de puro combustible para ganar masa muscular de verdad.',
    benefits: [
      '28.500mg de activos por porción',
      'Proteínas + carbohidratos + creatina + glutamina',
      '3kg — máxima duración y rendimiento',
      'Ideal para hardgainers y ectomorfos',
      'Superávit calórico controlado y efectivo',
      'Ganancia de masa muscular comprobada',
    ],
    waMessage:
      'Hola! Quiero el Anabolic MASS 28500 3kg en oferta por $1.390 UY. ¿Tienen stock disponible?',
  },
  {
    id: 8,
    name: 'Power Whey Protein Isolate 4 LB',
    includes: [],
    originalPrice: 7230,
    offerPrice: 5590,
    savings: 1640,
    image:
      'https://cdn.magicpatterns.com/uploads/amhzhq63fgh5pkD7ND4mgW/Powerwheyprotein4lb.png',
    pain: "¿Estás cansado de quedarte sin proteína a mitad de mes y frenar tu progreso? O peor, comprás un bote pequeño más caro por porción porque 'ahorrás' inicialmente. El ciclo de escasez destruye tu continuidad.",
    description:
      'El bote grande para el atleta serio. 4 libras de la mejor whey protein de CIBELES garantizan tu suplementación por un período extendido sin interrupciones. Más por menos, más consistencia, más resultados. Para los que van en serio.',
    benefits: [
      '4 LB — máxima duración y ahorro',
      'Alta concentración proteica por porción',
      'Ideal para atletas de entrenamiento frecuente',
      'Mejor costo por porción del mercado',
      'Sostenés tu suplementación sin cortes',
      'Músculo constante = resultados constantes',
    ],
    waMessage:
      'Hola! Quiero el Power Whey Protein Isolate 4 LB en oferta por $5.590 UY. ¿Tienen stock disponible?',
  },
  {
    id: 9,
    name: 'Combo XPro Nutrition',
    includes: [
      'Muscle Whey Protein 900g (XPro Nutrition)',
      'Creatine 100g (XPro Nutrition)',
      "BCAA's 100g (XPro Nutrition)",
    ],
    originalPrice: 1890,
    offerPrice: 1390,
    savings: 500,
    image:
      'https://cdn.magicpatterns.com/uploads/8ivnzAWjUhz6XttFZRKTpd/WhatsApp_Image_2026-08-31_at_6.03.43_PM.jpg',
    pain: '¿Querés arrancar a suplementarte en serio pero no sabés por dónde empezar y comprar proteína, creatina y aminoácidos por separado se te va del presupuesto?',
    description:
      'El pack completo de XPro Nutrition para empezar con todo: Muscle Whey Protein 900g (blend proteico superior con vitaminas y minerales), Creatine 100g de absorción ultra rápida y BCAA 100g en relación 2:1:1 sabor frutilla. Los tres pilares de la suplementación en un solo combo, al precio más accesible del catálogo.',
    benefits: [
      'Muscle Whey Protein 900g — blend proteico superior',
      'Creatine 100g de absorción ultra rápida',
      "BCAA's 100g en relación 2:1:1",
      'Los tres pilares en un solo pack',
      'Ideal para arrancar a suplementarte',
      'La mejor relación precio-calidad del catálogo',
    ],
    waMessage:
      "Hola! Quiero el Combo XPro Nutrition — Muscle Whey Protein 900g + Creatine 100g + BCAA's 100g en oferta por $1.390 UY. ¿Tienen stock disponible?",
  },
]
